import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AuthenticationState } from './auth.reducer'

export const getUserState =
  createFeatureSelector<AuthenticationState>('authentication')

export const getUser = createSelector(
  getUserState,
  (state: AuthenticationState) => state.user
)

export const getToken = createSelector(
  getUserState,
  (state: AuthenticationState) => state.user?.access_token
)

export const getisLoggedIn = createSelector(
  getUserState,
  (state: AuthenticationState) => state.isLoggedIn
)

export const getError = createSelector(
  getUserState,
  (state: AuthenticationState) => state.error
)

export const getLoading = createSelector(
  getUserState,
  (state: AuthenticationState) => state.loading
)

export const getAuthMe = createSelector(
  getUserState,
  (state: AuthenticationState) => state.me
)

export const getLoadingMe = createSelector(
  getUserState,
  (state: AuthenticationState) => state.loadingMe
)

export const getAuthMeError = createSelector(
  getUserState,
  (state: AuthenticationState) => state.errorMe
)
